import { API_CONSULT } from 'Constants/client-modules';
import * as ACTION_TYPES from './types';

const clientName = API_CONSULT;

export function getUserInfo(userUuid) {
  return {
    types: [
      ACTION_TYPES.USER_GET_REQUESTED,
      ACTION_TYPES.USER_GET_SUCCEED,
      ACTION_TYPES.USER_GET_FAILED,
    ],
    promise: client => client.get('/doctors/search', { params: { userUuid } }),
    options: {
      clientName,
    },
  };
}
